<form class="form-inline">
  <div class="form-group">
    <input type="text" class="form-control form-control-sm" id="username">
  </div>
  <div class="form-group" style="padding-left: 1px; padding-right: 1px;">
    <input type="password" class="form-control form-control-sm" id="pwd">
  </div>
  <button type="reset" class="btn btn-sm btn-primary">Login</button>
</form>
